/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_LeerjaarInputs */

const nl_common_leerjaar = /** @type {(inputs: Common_LeerjaarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leerjaar`)
};

/**

* @param {Common_LeerjaarInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const common_leerjaar = /** @type {((inputs?: Common_LeerjaarInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_LeerjaarInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_common_leerjaar(inputs)
});
export { common_leerjaar as "common.leerjaar" }